export const selectCardView = ({ pageSettings: { cardView } }) => cardView
